import { gql, useQuery } from '@apollo/client';

export interface CWMetricsVars {
  domainIdentifier?: string;
  metrics: string;
  startTime: Date;
  endTime: Date;
  period: number;
  isSDPDSMetric?: boolean;
}

export interface CWMetricsData {
  cwMetrics?: {
    timeStamps: Date[];
    externalMetrics: {
      values: number[];
      label: string;
    };
  };
  sdpdsCwMetrics?: {
    timeStamps: Date[];
    externalMetrics: {
      values: number[];
      label: string;
    };
  };
}
const GQL_CW_METRICS = gql`
  query getExternalCwMetrics(
    $domainIdentifier: String!
    $metrics: String!
    $startTime: Date!
    $endTime: Date!
    $period: Int!
  ) {
    cwMetrics(
      domainIdentifier: $domainIdentifier
      metrics: $metrics
      startTime: $startTime
      endTime: $endTime
      period: $period
    )
  }
`;

const GQL_SDPDS_CW_METRICS = gql`
  query getSDPDSCwMetrics(
    $metrics: String!
    $startTime: Date!
    $endTime: Date!
    $period: Int!
  ) {
    sdpdsCwMetrics(
      metrics: $metrics
      startTime: $startTime
      endTime: $endTime
      period: $period
    )
  }
`;

export const useGetExternalCwQuery = (vars: CWMetricsVars) => {
  const {
    isSDPDSMetric,
    domainIdentifier,
    metrics,
    startTime,
    endTime,
    period
  } = vars;

  const metricsQueryParams = {
    metrics,
    startTime,
    endTime,
    period
  };

  const queryVars = isSDPDSMetric
    ? metricsQueryParams
    : { ...metricsQueryParams, domainIdentifier };

  return useQuery<CWMetricsData, CWMetricsVars>(
    isSDPDSMetric ? GQL_SDPDS_CW_METRICS : GQL_CW_METRICS,
    {
      variables: queryVars,
    }
  );
};
